<script lang="ts">
  export let fontSize: string = '1.4em';
  export let lineHeight: string = '21px';
  export let letterSpacing: string = '0px';
  export let textAlign: string = 'center';
  export let color: string = '#949DB6';
  export let fontWeight: string = '400';

  const style = `
    font-size: ${fontSize};
    line-height: ${lineHeight};
    letter-spacing: ${letterSpacing};
    text-align: ${textAlign};
    color: ${color};
    font-weight: ${fontWeight};
  `;
</script>

<p {style}><slot /></p>

<style lang="scss">
  p {
    padding: 0;
    margin: 0;
  }
</style>
